import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Org } from 'ldt-identity-service-api';
import { AuthService } from 'src/app/auth/service/auth.service';
import { Observable } from 'rxjs';
import { WorkforceLayoutService } from '../workforce-layout.service';
import { WorkforceAppComponent } from '../app.wf.component';
import { ClipboardService } from 'ngx-clipboard';
import { NotificationService } from 'src/app/shared/notification-service/notification.service';

@Component({
  selector: 'app-workforce-api-keys',
  templateUrl: './api-keys.component.html',
  styleUrls: ['./api-keys.component.scss'],
  standalone: false
})
export class WorkforceApiKeysComponent implements OnInit {
  isSmallScreen$: Observable<boolean>;
  org: Org;
  canAdmin: boolean = false;

  constructor(
    private router: Router,
    private auth: AuthService,
    private layoutService: WorkforceLayoutService,
    private parent: WorkforceAppComponent,
    private clipboard: ClipboardService,
    private notify: NotificationService
  ) {
    this.isSmallScreen$ = this.layoutService.isSmallScreen$;
  }

  toggleThinSidenav() {
    this.parent.toggleThinSidenav();
  }

  ngOnInit() {
    const thisOrg = this.auth.getSelectedOrg();
    if (!thisOrg) {
      this.router.navigateByUrl('/insights');
    } else {
      this.org = thisOrg;
    }
    this.canAdmin = this.auth.userHasRole('admin');
  }

  copyOrgId() {
    if (!this.org || !this.org.id) {
      return;
    }
    this.clipboard.copyFromContent(this.org.id);
    this.notify.success('Copied Org ID to clipboard');
  }
}
